export default {
  props: {
    parentItem: {
      type: Object,
      default: () => {},
    },
    theme: String,
    iconSize: {
      type: Number,
      default: 20,
    },
  },
  computed: {
    parentName() {
      return this.parentName.name;
    },

    children() {
      return this.parentItem.children;
    },

    textColor() {
      return this.theme === 'dark' ? '#495060' : '#fff';
    },
  },
};
